"use client";

export default function OnboardDriverStatusPage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background text-foreground px-6 relative">
      <header className="absolute top-6 left-0 right-0 flex justify-center">
        <div className="flex items-center gap-3">
          <img src="/logo.svg" alt="Smart Taurus" className="h-8 w-auto" />
          <span className="sr-only">Smart Taurus</span>
        </div>
      </header>

      <main className="w-full max-w-lg text-center">
        <div className="rounded-3xl p-[1px] bg-gradient-to-br from-primary/20 via-muted-foreground/10 to-primary/20">
          <div className="rounded-3xl border bg-card/90 p-8 md:p-10 shadow">
            <div className="flex flex-col items-center">
              <div className="h-12 w-12 rounded-full bg-primary/10 text-primary flex items-center justify-center">
                <span className="text-xl">✓</span>
              </div>
              <p className="mt-6 text-lg font-semibold">Return to the app</p>
              <p className="mt-2 text-sm text-muted-foreground">You can now close this window and return to the Smart Taurus app to continue.</p>
            </div>
          </div>
        </div>
      </main>

      <footer className="absolute bottom-6 text-xs text-muted-foreground">Secure onboarding with Stripe</footer>
    </div>
  );
}


